<template>
  <div class="w-full">
    <component :areas="areas" :editObj="editObj" :is="activeAreaAffectedMod" :affectedAreaKeys="affectedAreaKeys"/>
  </div>
</template>

<script>
  import firebase from "firebase";
  import {eventBus} from "../../eventbus";
  import {db} from '@/db'
  import AreaAffectedAdd from "./AreaAffectedAdd";
  import AreaAffectedContent from "./AreaAffectedContent";
  import AreaAffectedEdit from "./AreaAffectedEdit";

  export default {
    name: "AreaAffectedIndex",
    components: {
      AreaAffectedAdd,
      AreaAffectedContent,
      AreaAffectedEdit,
    },
    data: () => ({
      affectedAreaKeys: [],
      areas: [],
      editObj: {},
      activeAreaAffectedMod: 'AreaAffectedContent'
    }),
    firebase: {
      areas: db.ref('affected_areas').orderByChild('area'),
    },
    watch: {
      areas() {
        this.getKeys()
      }
    },
    methods: {
      getKeys() {
        let keys = []
        firebase.database().ref('affected_areas/').once('value', function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let key = {key: childSnapshot.key}
            let value = childSnapshot.val()
            keys.push({...key, ...value})

          })
        })
        this.affectedAreaKeys = keys
      },
      listener() {
        eventBus.$on('AddArea', () => this.activeAreaAffectedMod = 'AreaAffectedAdd')
        eventBus.$on('AllArea', () => this.activeAreaAffectedMod = 'AreaAffectedContent')
        eventBus.$on('EditArea', (x) => {
          this.editObj = x;
          this.activeAreaAffectedMod = 'AreaAffectedEdit'

        })
      }
    },
    created() {
      this.listener()
    }
  }
</script>

<style scoped>

</style>